import * as React from 'react';
import { atom, useRecoilState } from 'recoil';

import { localStorage } from '@gitbook/util-local-storage';

const QUERIES_MEMORY = 10;

export interface AISearchQueryState {
    query: string;
    previousQueries: string[];
}

const aiSearchQueryAtom = atom<AISearchQueryState>({
    key: 'aiSearchQuery',
    default: {
        query: '',
        previousQueries: [],
    },
    effects: [
        localStorage.recoilEffect('@recoil/aiSearchQuery', {
            query: '',
            previousQueries: [],
        }),
    ],
});

/**
 * Hook to manage the state of a user submitted query, while storing the N previous queries.
 */
export function useAISearchQuery(): [AISearchQueryState, (newQuery: string) => void] {
    const [state, setState] = useRecoilState(aiSearchQueryAtom);

    const submitQuery = React.useCallback(
        (query: string) => {
            setState((prev) => {
                if (!prev) {
                    return {
                        query,
                        previousQueries: [],
                    };
                }

                return {
                    query,
                    previousQueries: [
                        ...prev.previousQueries.filter((q) => q !== query && q !== prev.query),
                        ...(prev.query ? [prev.query] : []),
                    ].slice(-QUERIES_MEMORY),
                };
            });
        },
        [setState]
    );

    return [state, submitQuery];
}
